import PropTypes from 'prop-types';

const CopyrightIcon = ({ color, className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill={color}
      width="15px"
      height="15px"
    >
      <path d="M6.56 7.145c.0375-.2475.12-.465.225-.6525.105-.1875.255-.345.4425-.465.18-.1125.405-.165.6825-.1725.1725.0075.33.0375.4725.0975.15.0675.285.1575.39.27.105.1125.1875.2475.255.3975.0675.15.0975.315.105.48h1.3425c-.015-.3525-.0825-.675-.21-.9675s-.3-.5475-.525-.7575c-.225-.21-.495-.375-.81-.495-.315-.12-.66-.1725-1.0425-.1725-.4875 0-.915.0825-1.275.255-.36.1725-.66.3975-.9.69-.24.2925-.42.63-.5325 1.02-.1125.39-.18.795-.18 1.23v.2025c0 .435.06.84.1725 1.23.1125.39.2925.7275.5325 1.0125.24.285.54.5175.9.6825.36.165.7875.255 1.275.255.3525 0 .6825-.06.99-.1725.3075-.1125.5775-.27.81-.4725.2325-.2025.42-.435.555-.705.135-.27.2175-.555.225-.8625H9.1175c-.0075.1575-.045.3-.1125.435a1.1036 1.1036 0 0 1-.27.345 1.1813 1.1813 0 0 1-.39.225c-.1425.0525-.2925.0675-.45.075-.27-.0075-.495-.06-.6675-.1725-.1875-.12-.3375-.2775-.4425-.465a1.9597 1.9597 0 0 1-.225-.66c-.0375-.2475-.06-.5025-.06-.75v-.2025c0-.2625.0225-.51.06-.7575ZM8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5ZM8 14c-3.3075 0-6-2.6925-6-6s2.6925-6 6-6 6 2.6925 6 6-2.6925 6-6 6Z" />
    </svg>
  );
};

export default CopyrightIcon;

CopyrightIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};
